import classNames from 'classnames';
import React from 'react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './quick-link-card.module.scss';

export interface QuickLinkCardProps {
  /** The class name to apply */
  className?: string;
  /** The icon to show */
  icon?: Content.Components['QuickLinksItemDto']['icon'];
  /** The link to show */
  link?: Content.Components['QuickLinksItemDto']['link'];
}

const QuickLinkCard = ({ className, icon, link }: QuickLinkCardProps) => {
  return (
    <Link
      className={classNames(styles.component, className)}
      target={link?.target}
      url={link?.url}
    >
      {icon && (
        <Icon className={styles.icon} name={icon as IconName} size={40} />
      )}

      {link && (
        <Typography className={styles.text} tagStyle="bodyMediumBold">
          {link.text}
        </Typography>
      )}
    </Link>
  );
};

QuickLinkCard.displayName = 'QuickLinkCard';

export default QuickLinkCard;
